<template>
  <div>
    <v-card v-if="materialData" min-width="300">
      <v-card-title class="d-flex flex-row align-start cardHeaderGradient">
        <div class="d-flex flex-row">
          <div v-if="materialData.image">
            <v-img
              contain
              max-height="50"
              max-width="130"
              position="left center"
              :src="imgPath + materialData.image"
            ></v-img>
          </div>
          <div v-else>{{ materialData.name }}</div>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text class="scroll">
        <!-- <div>{{ materialTypeNameForId(materialData.materialTypeId) }}</div> -->
        <!-- {{ tableData }} -->
        <v-data-table
          :headers="isMobile ? mobileHeader : headers"
          :items="tableData"
          dense
          hide-default-footer
          hide-default-header
          :items-per-page="-1"
        >
          <template v-slot:item.label="{ item }"
            ><div class="font-weight-medium">{{ item.label | titleize }}</div>
          </template>

          <template v-slot:item.value="{ item }">
            {{
              boolFields.includes(item.key)
                ? strForBool(item.value)
                : item.value
            }}
          </template>

          <template v-slot:item.unoField="{ item }">
            <div class="width100p align-start">
              <div
                class="font-weight-medium mobileFieldTitle text-left px-2 d-inline-block"
              >
                {{ item.label | titleize }}
              </div>
              <div class="px-2 text-left d-inline-block">
                {{ item.value }}
              </div>
            </div>
          </template>
        </v-data-table>

        <div class="mt-4 darkerCardText" v-if="materialData.otherInfo">
          <div class="overline">Other Info</div>
          <div v-if="materialData.url">
            <v-btn
              small
              text
              color="primary"
              :href="materialData.url"
              target="_blank"
            >
              <v-icon small class="mr-2">mdi-web</v-icon>
              Material Website</v-btn
            >
          </div>
          <vue-markdown>{{ materialData.otherInfo }}</vue-markdown>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import Name from "../dir/file";
import RgpOptionsMixin from "@/assets/js/rgps/RgpOptionsMixin.js";

export default {
  name: "MaterialDetailCard",
  components: {
    VueMarkdown: () => import("@adapttive/vue-markdown"),
  },

  mixins: [RgpOptionsMixin],
  props: {
    materialData: null,
    rgpOptions: null,
  },
  data: function () {
    return {
      imgPath: "https://www.eyedock.com/images/rgp_materials/",
      headers: [
        { text: "Label", value: "label" },
        { text: "Value", value: "value" },
      ],
      mobileHeader: [{ text: "", value: "unoField" }],
      keyList: {
        companyName: { text: "Company" },
        type: { text: "Material Type" },
        generic_name: { text: "Generic" },
        specificGravity: { text: "Specific Gravity" },
        refractiveIndex: { text: "Refractive Index" },
        wetAngle: { text: "Wetting Angle" },
        uv: { text: "UV" },
        largeDiams: { text: "Large Diameters?" },
        colors: { text: "Colors" },
        colorsUV: { text: "Colors (UV)" },
        light_transmission: { text: "Light Trans." },
        rockwell_hardness: { text: "Rockwell Hardness" },
        shore_hardness: { text: "Shore Hardness" },

        id: { hide: true },

        name: { hide: true, text: "Name" },
        materialTypeId: { hide: true },
        otherInfo: { hide: true },
        companyId: { hide: true },
        url: { hide: true },
        image: { hide: true },
        display: { hide: true },
        added: { hide: true },
        updated: { hide: true },
      },
      boolFields: ["uv", "largeDiams"],
    };
  },
  methods: {
    include(key) {
      let obj = this.keyList[key];
      // if (key == "name" && this.materialData.image) return true;
      if (
        this.boolFields.includes(key) &&
        parseInt(this.materialData?.[key]) != 1
      )
        return false;
      if (obj && "hide" in obj && obj.hide) return false;
      return true;
    },
    nameForKey(key) {
      //   return key;
      let obj = this.keyList[key];
      if (obj && obj.text) return obj.text;
      return key.replace(/_/g, " ").replace(/-/g, " ");
    },
    strForBool(val) {
      return parseInt(val) == 1 ? "Yes" : "No";
    },
  },
  computed: {
    includeName: function () {
      let rtn = [];
      let md = this.materialData;
      if (!md) return rtn;
      if (md.image) {
        rtn.push({
          label: "Material",
          value: md.name,
          key: "material",
        });
      }
      // if (md.companyId) {
      //   rtn.push({
      //     label: "Company",
      //     value: this.materialCompanyNameForId(md.companyId),
      //     key: "company",
      //   });
      // }
      // if (md.materialTypeId) {
      //   rtn.push({
      //     label: "Material Type",
      //     value: this.materialTypeNameForId(md.materialTypeId),
      //     key: "material_type",
      //   });
      // }
      return rtn;
    },
    tableData: function () {
      let md = this.materialData;
      if (!md) return [];
      let that = this;
      let keyListKeys = Object.keys(this.keyList);
      let dataKeys = Object.keys(md);
      // merge the above - filter out duplicates first
      let keys = keyListKeys.concat(
        dataKeys.filter((item) => keyListKeys.indexOf(item) < 0)
      );
      // console.log(keys);
      let rtn = this.includeName;
      keys.forEach((key) => {
        // console.log(key, md[key]);
        let include = that.include(key);
        if (include && md[key] && md[key] != "") {
          let keyLabel = that.nameForKey(key);
          let obj = {};
          obj.label = keyLabel;
          obj.value = md[key];
          obj.key = key;
          rtn.push(obj);
        }
      });
      // console.log(rtn);
      return rtn;
    },

    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
  },
};
</script>

<style scoped>
.key {
  width: 100px;
}
.mobileFieldTitle {
  width: 120px;
}
.mobileValue {
  min-width: 140px;
}
.scroll {
  overflow-y: scroll;
  max-height: calc(100vh - 200px);
}
</style>
